import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/apiService";

export const GetOneEventsActivities = createAsyncThunk(
  "GetOneEventsActivities/GetOneEventsActivities",
  async (pR_EventsActivitiesGUID, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_EventsActivities/GetPR_EventsActivitiesData",
        {
          pR_EventsActivitiesGUID: pR_EventsActivitiesGUID,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const DeleteEventsActivities = createAsyncThunk(
  "DeleteEventsActivities/DeleteEventsActivities",
  async (pR_EventsActivitiesGUID, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_EventsActivities/DeletePR_EventsActivitiesData",
        {
          pR_EventsActivitiesGUID: pR_EventsActivitiesGUID,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const GetListEventsActivities = createAsyncThunk(
  "GetListEventsActivities/GetListEventsActivities",
  async (pR_ReportsStagesGuid, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_EventsActivities/GetPR_EventsActivitiesListData",
        {
          pR_ReportsStagesGuid: pR_ReportsStagesGuid,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const UpdateEventsActivitiesData = createAsyncThunk(
  "UpdateEventsActivities/UpdateEventsActivities",
  async (EventsActivities, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_EventsActivities/UpdatePR_EventsActivitiesData",
        {
          pR_EventsActivitiesGUID: EventsActivities.pR_EventsActivitiesGUID,
          activityName: EventsActivities.activityName,
          pR_NationalityId: EventsActivities.pR_NationalityId,
          pR_TypeOfActivityId: EventsActivities.pR_TypeOfActivityId,
          durationDays: EventsActivities.durationDays,
          activityStartDate: EventsActivities.activityStartDate,
          activityEndDate: EventsActivities.activityEndDate,
          pR_ReportsStagesGuid: EventsActivities.pR_ReportsStagesGuid,
          pR_AgeGroupID: EventsActivities.pR_AgeGroupID,
          pR_CityId: EventsActivities.pR_CityId,
          total: EventsActivities.total,
          numberOfFemale: EventsActivities.numberOfFemale,
          numberOfMale: EventsActivities.numberOfMale,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const AddEventsActivitiesData = createAsyncThunk(
  "AddEventsActivities/AddEventsActivities",
  async (EventsActivities, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_EventsActivities/AddPR_EventsActivitiesData",
        {
          activityName: EventsActivities.activityName,
          pR_NationalityId: EventsActivities.pR_NationalityId,
          pR_TypeOfActivityId: EventsActivities.pR_TypeOfActivityId,
          durationDays: EventsActivities.durationDays,
          activityStartDate: EventsActivities.activityStartDate,
          activityEndDate: EventsActivities.activityEndDate,
          pR_ReportsStagesGuid: EventsActivities.pR_ReportsStagesGuid,
          pR_AgeGroupID: EventsActivities.pR_AgeGroupID,
          pR_CityId: EventsActivities.pR_CityId,
          total: EventsActivities.total,
          numberOfFemale: EventsActivities.numberOfFemale,
          numberOfMale: EventsActivities.numberOfMale,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "addJobOpportun");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const ValidateEventsActivities = createAsyncThunk(
  "ValidateEventsActivities/ValidateEventsActivities",
  async (EventsActivities, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_EventsActivities/ValidatePR_EventsActivitiesData",
        {
          activityName: EventsActivities.activityName,
          pR_NationalityId: EventsActivities.pR_NationalityId,
          pR_TypeOfActivityId: EventsActivities.pR_TypeOfActivityId,
          durationDays: EventsActivities.durationDays,
          activityStartDate: EventsActivities.activityStartDate,
          activityEndDate: EventsActivities.activityEndDate,
          pR_AgeGroupID: EventsActivities.pR_AgeGroupID,
          pR_CityId: EventsActivities.pR_CityId,
          numberOfFemale: EventsActivities.numberOfFemale,
          numberOfMale: EventsActivities.numberOfMale,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      if (response.data.success === true) {
        const arrayValidate = response.data.result.map((ele, ind) => {
          return ele.code;
        });
        return arrayValidate; // Return the extracted data
      }
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetSpecificRowNoteEventsActivities = createAsyncThunk(
  "GetSpecificRowNoteEventsActivities/GetSpecificRowNoteEventsActivities",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_TechnicalReportNotes/GetPR_TechnicalReportNotesSubmitterData",
        parameters
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      // return data.filter((item) => item.incrementNumber - 1 === 1);
        return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const EventsActivities = createSlice({
  name: "EventsActivities",
  initialState: {
    OneEventsActivities: {},
    loadingOneEventsActivities: false,
    errorOneEventsActivities: null,

    AddEventsActivities: {},
    loadingAddEventsActivities: false,
    errorAddEventsActivities: null,

    UpdateEventsActivities: {},
    loadingUpdateEventsActivities: false,
    errorUpdateEventsActivities: null,

    DeleteEventsActivities: {},
    loadingDeleteEventsActivities: false,
    errorDeleteEventsActivities: null,

    ListEventsActivities: {},
    loadingListEventsActivities: false,
    errorListEventsActivities: null,

    EventsActivitiesValidate: [],
    loadingEventsActivitiesValidate: false,
    errorEventsActivitiesValidate: null,

    OneSpecificRowNoteEventsActivities: {},
    loadingOneSpecificRowNoteEventsActivities: false,
    errorOneSpecificRowNoteEventsActivities: null,
  },
  reducers: {
    restValidateEventsActivities: (state, action) => {
      state.EventsActivitiesValidate = [];
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(GetOneEventsActivities.pending, (state, action) => {
        state.loadingOneEventsActivities = true;
        state.OneEventsActivities = action.payload;
        state.errorOneEventsActivities = null;
      })
      .addCase(GetOneEventsActivities.fulfilled, (state, action) => {
        state.loadingOneEventsActivities = false;
        state.OneEventsActivities = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetOneEventsActivities.rejected, (state, action) => {
        state.loadingOneEventsActivities = false;
        state.errorOneEventsActivities = action.payload;
      })

      .addCase(DeleteEventsActivities.pending, (state, action) => {
        state.loadingDeleteEventsActivities = true;
        state.DeleteEventsActivities = action.payload;
        state.errorDeleteEventsActivities = null;
      })
      .addCase(DeleteEventsActivities.fulfilled, (state, action) => {
        state.DeleteEventsActivities = false;
        state.DeleteEventsActivities = action.payload; // Assuming payload has the desired data
      })
      .addCase(DeleteEventsActivities.rejected, (state, action) => {
        state.loadingDeleteEventsActivities = false;
        state.errorDeleteEventsActivities = action.payload;
      })
      .addCase(GetListEventsActivities.pending, (state, action) => {
        state.loadingListEventsActivities = true;
        state.ListEventsActivities = action.payload;
        state.errorListEventsActivities = null;
      })
      .addCase(GetListEventsActivities.fulfilled, (state, action) => {
        state.loadingListEventsActivities = false;
        state.ListEventsActivities = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetListEventsActivities.rejected, (state, action) => {
        state.loadingListEventsActivities = false;
        state.errorListEventsActivities = action.payload;
      })
      .addCase(UpdateEventsActivitiesData.pending, (state, action) => {
        state.loadingUpdateEventsActivities = true;
        state.UpdateEventsActivities = action.payload;
        state.errorUpdateEventsActivities = null;
      })
      .addCase(UpdateEventsActivitiesData.fulfilled, (state, action) => {
        state.loadingUpdateEventsActivities = false;
        state.UpdateEventsActivities = action.payload; // Assuming payload has the desired data
      })
      .addCase(UpdateEventsActivitiesData.rejected, (state, action) => {
        state.loadingUpdateEventsActivities = false;
        state.errorUpdateEventsActivities = action.payload;
      })
      .addCase(ValidateEventsActivities.pending, (state, action) => {
        state.loadingEventsActivitiesValidate = true;
        state.EventsActivitiesValidate = action.payload;
        state.errorEventsActivitiesValidate = null;
      })
      .addCase(ValidateEventsActivities.fulfilled, (state, action) => {
        state.loadingEventsActivitiesValidate = false;
        state.EventsActivitiesValidate = action.payload; // Assuming payload has the desired data
      })
      .addCase(ValidateEventsActivities.rejected, (state, action) => {
        state.loadingEventsActivitiesValidate = false;
        state.errorEventsActivitiesValidate = action.payload;
      })
      .addCase(AddEventsActivitiesData.pending, (state, action) => {
        state.loadingAddEventsActivities = true;
        state.AddEventsActivities = action.payload;
        state.errorAddEventsActivities = null;
      })
      .addCase(AddEventsActivitiesData.fulfilled, (state, action) => {
        state.loadingAddEventsActivities = false;
        state.AddEventsActivities = action.payload; // Assuming payload has the desired data
      })
      .addCase(AddEventsActivitiesData.rejected, (state, action) => {
        state.loadingAddEventsActivities = false;
        state.errorAddEventsActivities = action.payload;
      })
      .addCase(GetSpecificRowNoteEventsActivities.pending, (state, action) => {
        state.loadingOneSpecificRowNoteEventsActivities = true;
        state.OneSpecificRowNoteEventsActivities = action.payload;
        state.errorOneSpecificRowNoteEventsActivities = null;
      })
      .addCase(
        GetSpecificRowNoteEventsActivities.fulfilled,
        (state, action) => {
          state.loadingOneSpecificRowNoteEventsActivities = false;
          state.OneSpecificRowNoteEventsActivities = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(GetSpecificRowNoteEventsActivities.rejected, (state, action) => {
        state.loadingOneSpecificRowNoteEventsActivities = false;
        state.errorOneSpecificRowNoteEventsActivities = action.payload;
      });
  },
});
export const { restValidateEventsActivities } = EventsActivities.actions;
export default EventsActivities.reducer;
